<template>
  <div class="text-center" style="margin-top: 10vh">
    <h1>Oops!</h1>
    <h3>The page you're looking for is not here.</h3>
    <span class="pointer underline" @click="redirectTo()">Back to page</span>
    <span class="pointer underline ml-20" @click="logout()">Logout</span>
  </div>
</template>

<script>
export default {
  methods: {
    redirectTo() {
      if (
        this.$permission('Dashboard.Pod Accel.View') ||
        this.$permission('Dashboard.Pod Capacitance.View') ||
        this.$permission('Dashboard.Pod Data Stream.View')
      ) {
        this.$router.push({ path: '/' })
      } else if (
        this.$permission('Products.Manufacturers.View') ||
        this.$permission('Products.Product Description.View') ||
        this.$permission('Products.Product Characteristics.View') ||
        this.$permission('Products.Run.View') ||
        this.$permission('Products.Analyse Runs.View')
      ) {
        this.$router.push({ path: '/products' })
      } else if (
        this.$permission('Pods.Capacitance Readings Chart.View') ||
        this.$permission('Pods.Connection Status Chart.View') ||
        this.$permission('Pods.Battery Levels Chart.View') ||
        this.$permission('Pods.Accelerometer Readings Chart.View') ||
        this.$permission('Pods.Temperature Chart.View') ||
        this.$permission('Pods.SPO2 Chart.View') ||
        this.$permission('Pods.Calibration.View') ||
        this.$permission('Pods.Find Data.View') ||
        this.$permission('Pods.Diagnostics.View') ||
        this.$permission('Pods.Live Data.View')
      ) {
        this.$router.push({ path: '/pods' })
      } else if (this.$permission('Reports.Export CSV.Export')) {
        this.$router.push({ path: '/reports' })
      } else if (
        this.$permission('Production.Monitoring.View') ||
        this.$permission('Production.Test Reports.View') ||
        this.$permission('Production.Acceptance Criteria.View') ||
        this.$permission('Production.Firmware & Software.View')
      ) {
        this.$router.push({ path: '/production' })
      } else {
        this.$router.push({ path: '/manage' })
      }
    },
    logout() {
      localStorage.removeItem('user')
      this.$router.push({ path: '/login' })
    }
  }
}
</script>
